import { createFileRoute } from "@tanstack/react-router"

import { InhaltePage } from "@/components/admin/inhalte/inhalte-page"

export const Route = createFileRoute("/_app/admin/inhalte")({
  component: InhaltePage,
})
